export const MAP_FIT_BOUNDS_PADDING = {
  left: 90,
  top: 90,
  bottom: 90,
  right: 90
};

export const MODAL_MAP_FIT_BOUNDS_PADDING = {
  left: 470,
  top: 90,
  bottom: 90,
  right: 90
};

export const MOBILE_ROUTE_MAP_FIT_BOUNDS_PADDING = {
  left: 90,
  top: 90,
  bottom: 350,
  right: 90
};
